// extracted by mini-css-extract-plugin
export default {"tabletImg":"AJ","desktopImg":"BJ","mobileImg":"CJ","backgroundImage":"EJ","content":"FJ","rtbLeft":"GJ","rtbRight":"HJ","imageContainer":"IJ","rtbBox":"JJ","line":"KJ","rtbLeftMobile":"LJ","rtbDesktop":"MJ"};
    if(module.hot) {
      // 1715188236800
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  